import React, { useEffect, useState, useRef, } from 'react';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../lib/hooks.js';
import { getRoundLabel, adaptHeightOnWidget, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

import LoserCross from '../svg/LoserCross';
import WinnerStar from '../svg/WinnerStar';

import ActionLink from '../builder/ActionLink';
import Spinner from '../builder/Spinner';

import RoundVotesLayer from '../front/layers/RoundVotesLayer';

let outline_color = 'rgba(255, 255, 255, 0.5)';
let white_color = 'rgba(255, 255, 255, 1)';
let black_color = 'rgba(0, 0, 0, 1)';

let throttle_resize;

const Team = (props) => {
	const bracket = props.bracket;
	const round = parseInt(props.round);

	const teams_display = (bracket.teams_display != undefined) ? parseInt(bracket.teams_display) : 0;
	const display_team_images = (teams_display > 0) ? true : false;
	const display_team_full_name = (teams_display < 2) ? true : false;
	const display_team_images_only = (display_team_images && teams_display == 3) ? true : false;
	const display_team_texts = (!display_team_images_only) ? true : false;

	const autoflip_candidates = (bracket.autoflip_candidates != undefined && bracket.autoflip_candidates == '1') ? true : false;

	const losers_display = (bracket.losers_display != undefined) ? bracket.losers_display : false;
	const display_scores = (bracket.display_scores != undefined && bracket.display_scores == '1') ? true : false;
	const bracket_layout = (props.bracket_layout != undefined) ? props.bracket_layout : 'light';

	let box_proportion = false;
	switch(teams_display) {
		case 0:
			// only the full name:
			break;
		case 1:
			// both image the full name:
			break;
		case 2:
			// both image and short name:
			box_proportion = '3x1';
			break;
		case 3:
			// only the image:
			box_proportion = '2x1';
			break;
	}

	const team = (props.team != undefined) ? props.team : false;

	const is_winner = (props.is_winner != undefined) ? props.is_winner : false;
	const is_loser = (props.is_loser != undefined) ? props.is_loser : false;
	const is_blurred = (is_loser && (losers_display == '2' || losers_display == '3')) ? true : false;
	const is_crossed = (is_loser && (losers_display == '1' || losers_display == '3')) ? true : false;
	const score = (props.score != undefined) ? props.score : false;

	const box_bg = props.generic_box_bg;
	const has_custom_bg_color = (team !== false && team.color != undefined && team.color != "") ? true : false;
	const team_color = (has_custom_bg_color && !is_blurred) ? team.color : box_bg;
	const is_team_color_bright = (isColorBright(RGB_2_HEX(team_color))) ? true : false;

	let team_box_classes = ['team', `is_${(is_team_color_bright) ? 'light' : 'dark'}_team`];
	if(team !== false) team_box_classes.push(`team_${team.id}`);
	if(team === false) team_box_classes.push('is_pending');
	if(box_proportion !== false) team_box_classes.push(`fixed_proportion is_${box_proportion}`);
	if(display_team_images_only) team_box_classes.push('only_image');
	if(is_winner) team_box_classes.push('is_winner');
	if(is_loser) team_box_classes.push('is_loser');
	if(is_blurred) team_box_classes.push('is_blurred');

	let has_image = (team !== false && team.full_thumb_image != undefined) ? true : false;
	let has_bg_image = (team !== false && team.full_background != undefined) ? true : false;
	if(autoflip_candidates) {
		if(!display_team_images_only || !has_bg_image) team_box_classes.push('autoflip_candidates');
	}

	return (
		<div class={team_box_classes.join(" ")}>
			{(box_proportion !== false) && (
				<img src={`${window.cdn_url}img/blank_${box_proportion}.png`} width="100%" />
			)}

			{(!display_team_images_only) ? (
				<span class="team_contents" style={{ background:team_color }}>
					{(display_team_images) && (
						<span class="team_img" style={(has_image) ? { backgroundImage:`url(${team.full_thumb_image})` } : null}>
							<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" />
						</span>
					)}

					<span class="team_name">
						{(team !== false) ? ((display_team_full_name) ? team.name : team.short_name) : ""}

						{(is_crossed) && (
							<LoserCross />
						)}
					</span>
				</span>
			) : (
				<span class="team_contents">
					<span class="team_img" style={(has_bg_image || has_image) ? { backgroundImage:`url(${(has_bg_image) ? team.full_background : team.full_thumb_image})` } : null}>
						<img src={`${window.cdn_url}img/blank_${box_proportion}.png`} width="100%" />
					</span>

					{(is_crossed) && (
						<span class="team_name">
							<LoserCross />
						</span>
					)}
				</span>
			)}

			{(round == parseInt(bracket.num_rounds) && is_winner) && (
				<WinnerStar />
			)}

			{((display_scores) && score) && (
				<span class="score">
					<span class="gui_cutTextOnOverflow" style={{color:props.header_color}}>{score}</span>
				</span>
			)}
		</div>
	);
};

const RoundColumn = (props) => {
	const match = props.match;

	let teamA_props = { };
	let teamB_props = { };

	if(match.teams != undefined) {
		teamA_props.team = props.teams.find((obj) => { return obj.id == match.teams[0]; });
		teamB_props.team = props.teams.find((obj) => { return obj.id == match.teams[1]; });

		if(match.winner != undefined && match.winner != "") {
			teamA_props.score = match.score[0];
			teamB_props.score = match.score[1];

			if(teamA_props.team.id == match.winner) {
				teamA_props.is_winner = true;
				teamB_props.is_loser  = true;
			}

			if(teamB_props.team.id == match.winner) {
				teamA_props.is_loser  = true;
				teamB_props.is_winner = true;
			}
		}
	}

	let team_props = {
		round:props.round,
		bracket:props.bracket,
		bracket_layout:props.bracket_layout,
		generic_box_bg:props.generic_box_bg,
		header_color:props.header_color,
	};

	return (
		<div class="match">
			<div>
				<Team {...team_props} {...teamA_props} />
				<Team {...team_props} {...teamB_props} />
			</div>
		</div>
	)
};

const BracketsCanvas = (props) => {
	useCSS('comp/brackets.css');

	const bracket = (props.bracket != undefined) ? props.bracket : false;
	const teams = (props.teams != undefined) ? props.teams : false;

	if(!teams || !bracket) return null;

	const is_builder = (props.is_builder != undefined) ? props.is_builder : false;
	const matches_results = (props.matches_results != undefined) ? props.matches_results : false;
	const promotion = (props.promotion != undefined) ? props.promotion : false;
	const main_color = (props.main_color != undefined) ? props.main_color : '#2951CC';

	const num_rounds = parseInt(bracket.num_rounds);
	let current_round = parseInt((props.current_round != undefined) ? props.current_round : bracket.current_round);

	const [is_loading, setIsLoading] = useState(true);
	const [bracket_scale, setBracketScale] = useState(1);
	const [display_round_votes, setDisplayRoundVotes] = useState(false);
	const [is_bracket_smaller_than_window, setIsBracketSmallerThanWindow] = useState(false);
	const [is_bracket_upper_than_back, setIsBracketUpperThanBack] = useState(0);

	let full_w = useRef(false);
	let full_h = useRef(false);
	let adapt_bracket = useRef(true);
	let whole_bg_size = useRef({ width:2000, height:1300 });
	const fit_type = 'w';	// "h" | "w"

	const round_width = 160;	// px

	useEffect(() => {
		const t = setTimeout(() => {
			const bracket_cont = document.getElementById('bracket_cont');
			full_w.current = bracket_cont.getBoundingClientRect().width;
			full_h.current = bracket_cont.getBoundingClientRect().height;

			adaptBracketToContainer();
			get_whole_bg_size();
			window.addEventListener('resize', adaptBracketToContainer);
		}, 400);

		return () => {
			window.removeEventListener('resize', adaptBracketToContainer);
		};
	}, []);

	useEffect(() => {
		const t = setTimeout(() => {
			const bracket_cont = document.getElementById('bracket_cont');
			full_w.current = bracket_cont.getBoundingClientRect().width;
			full_h.current = bracket_cont.getBoundingClientRect().height;

			get_whole_bg_size();
		}, 100);
	}, [bracket.teams_display]);

	const getMatchesInRound = (round, direction) => {
		let matches = [];

		if(bracket.current_round > 0) {
			if(round < current_round + 1) {
				for(const match in matches_results) {
					if(matches_results[match].round == round) {
						matches.push(matches_results[match]);
					}
				}
			}

			if(matches.length == 0) {
				if(round == current_round + 1) {
					let previous_round = [];
					for(const match in matches_results) {
						if(matches_results[match].round == round - 1) {
							previous_round.push(matches_results[match]);
						}
					}

					for(var i = 0; i < previous_round.length; i = i + 2) {
						let first = previous_round[i];
						let second = previous_round[i + 1];
						let this_match = {
							round:round + 1,
							winner:null,
							votes:[null, null],
							score:[null, null],
							teams:[first?.winner ?? {}, second?.winner ?? {}],
						};
						matches.push(this_match);
					}
				}
			}
		} else if(round == 1) {
			if (props.teams.length % 2 == 0) {
				// For UNDER CONSTRUCTION BRACKET (without any match created yet):
				for(var i = 0; i < props.teams.length; i = i + 2) {
					let first = props.teams[i];
					let second = props.teams[i + 1];
					let this_match = {
						round:round,
						winner:null,
						votes:[null, null],
						score:[null, null],
						teams:[first.id, second.id],
					};
					matches.push(this_match);
				}
			}
		}

		const expected_matches_in_round = Math.pow(2, num_rounds - round);

		if(matches.length < expected_matches_in_round) {
			for(var i = matches.length; i < expected_matches_in_round; i++) {
				matches.push({ });
			}
		}

		let returnable_matches = (direction > 0) ? matches.slice(0, Math.ceil(matches.length / 2)) : matches.slice(Math.floor(matches.length / 2));

		return returnable_matches;
	};

	const fetchRounds = () => {
		let rounds = [];

		for(var i = 1; i < num_rounds + 1; i++) {
			let round = {
				round:i,
				label:getRoundLabel(bracket, i, false, props.intl),
				matches:getMatchesInRound(i, 1),
			};

			if(i == num_rounds) round.is_final = true;

			rounds.push(round);
		}

		for(var i = num_rounds - 1; i > 0; i--) {
			let round = {
				round:i,
				label:getRoundLabel(bracket, i, false, props.intl),
				matches:getMatchesInRound(i, -1),
				reversed:true,
			};

			rounds.push(round);
		}

		return rounds;
	};

	const adaptBracketToContainer = () => {
		const _c = document.getElementById('bracket_dom');
		const parent_height = _c.getBoundingClientRect().height;
		const parent_width = _c.getBoundingClientRect().width;

		adapt_bracket.current = (parent_width > 700) ? true : false;

		const back_height = calculateBackHeight();
		setIsBracketSmallerThanWindow((((parent_height - back_height) / full_h.current) < 1) ? false : true);

		if(!adapt_bracket.current) {
			_c.classList.remove('is_scaled', 'is_' + fit_type);
			_c.classList.add('is_not_scaled');

			setBracketScale(1);
			if(is_loading) setIsLoading(false);
			calculateTopPosition(back_height, parent_height);
			adaptHeightOnWidget(parent_height);

			return false;
		}

		if(!is_loading) setIsLoading(true);

		if(throttle_resize != undefined) clearTimeout(throttle_resize);

		throttle_resize = setTimeout(() => {
			const scale = (fit_type == 'h') ? parent_height / full_h.current : parent_width / full_w.current;

			const bracket_scale = Math.min(1, scale);
			if(bracket_scale < 1) {
				_c.classList.add('is_scaled', 'is_' + fit_type);
				_c.classList.remove('is_not_scaled');
			} else {
				_c.classList.remove('is_scaled', 'is_' + fit_type);
				_c.classList.add('is_not_scaled');
			}

			if(is_loading) setIsLoading(false);
			setBracketScale(bracket_scale);
			calculateTopPosition(back_height, parent_height);
			adaptHeightOnWidget(scale * full_h.current);
		}, 150);
	};

	const calculateBackHeight = () => {
		let back_height = 0;
		if(document.getElementById('floating_back') != undefined) {
			back_height = document.getElementById('floating_back').getBoundingClientRect().height;
		}

		return back_height;
	};

	const calculateTopPosition = (back_height, parent_height) => {
		let new_top_position = 0;
		if(back_height > 0) {
			const empty_h_distance_in_bracket = full_h.current - parent_height;
			new_top_position = Math.max(new_top_position, (empty_h_distance_in_bracket / 2), (back_height / 2));
		}
		setIsBracketUpperThanBack(new_top_position);
	};

	const get_whole_bg_size = () => {
		if(is_builder && props.getBgSize != undefined) {
			const bracket_matches = document.getElementById('bracket_matches');
			const bracket_matches_w = bracket_matches.getBoundingClientRect().width;
			const bracket_matches_h = bracket_matches.getBoundingClientRect().height;

			let expected_width = 2000;
			let expected_height = Math.ceil(bracket_matches_h * expected_width / bracket_matches_w);

			props.getBgSize({ width:expected_width, height:expected_height });
		}
	};

	const rounds = fetchRounds();

	let bracket_styles = {
		width:rounds.length * round_width,
		transform:'scale(' + bracket_scale + ')',
	};
	if(is_loading) bracket_styles.opacity = '0';

	let bracket_bg_styles = { backgroundColor:(bracket.background_color != undefined && bracket.background_color != "") ? bracket.background_color : '#FFFFFF' };
	if(bracket.full_background_img != undefined) bracket_bg_styles.backgroundImage = 'url(' + bracket.full_background_img + ')';

	const bracket_layout = (bracket.layout != undefined) ? bracket.layout : 'light';
	const display_votes = (bracket.display_votes != undefined && bracket.display_votes == '1') ? true : false;

	let bracket_classes = ['_bracket', `is_${bracket_layout}_bracket`, `has_${num_rounds}_rounds`];

	const generic_box_bg = (bracket_layout == 'light') ? white_color : black_color;

	const header_color = (bracket.header_color != undefined && bracket.header_color != "") ? bracket.header_color : main_color;

	let round_props = {
		bracket:bracket,
		bracket_layout:bracket_layout,
		generic_box_bg:generic_box_bg,
		header_color:header_color,
		teams:teams,
	}

	const is_header_color_bright = (isColorBright(RGB_2_HEX(header_color))) ? true : false;
	let header_classes = ['bracket_header', 'is_' + ((is_header_color_bright) ? 'light' : 'dark') + '_header'];

	const teams_display = (bracket.teams_display != undefined) ? parseInt(bracket.teams_display) : 0;
	const display_team_images = (teams_display > 0) ? true : false;
	const display_team_images_only = (display_team_images && teams_display == 3) ? true : false;
	let matches_classes = ['bracket_matches'];
	if(display_team_images_only) matches_classes.push('only_images');

	const is_voting_bracket = (bracket.type == 1) ? true : false;

	let scaled_viewport_scale = { width:'100%', height:'100%' };
	if(full_h.current !== false) scaled_viewport_scale.height = (bracket_scale * full_h.current) + 'px';
	if(full_w.current !== false) scaled_viewport_scale.width = (bracket_scale * full_w.current) + 'px';
	if(is_bracket_smaller_than_window) {
		scaled_viewport_scale.alignSelf = 'center';
		scaled_viewport_scale.top = '-' + is_bracket_upper_than_back + 'px';
	}

	const column_styles = { flexBasis:round_width + 'px' };

	return (
		<div style={scaled_viewport_scale}>
			<div id="bracket_cont" class={bracket_classes.join(" ")} style={bracket_styles}>
				<div class={header_classes.join(" ")} style={{background:header_color}}>
					{rounds.map((round, r) => {
						const round_number = round.round;

						let round_classes = ['round_header', 'round_' + round_number];
						if(round_number == current_round) round_classes.push('is_current');

						let is_previous_round = (current_round > round_number) ? true : false;
						let is_future_round = (current_round < round_number) ? true : false;

						let display_link_by_type = (is_voting_bracket) ? is_previous_round : !is_future_round;

						return (
							<div key={`header_${r}`} class={round_classes.join(" ")} style={column_styles}>
								{round.label}

								{(display_link_by_type && display_votes) && (
									<ActionLink _class={{other:'original_color_item'}} onClick={(!is_builder) ? () => setDisplayRoundVotes(round_number) : null}>View votes</ActionLink>
								)}
							</div>
						)
					})}
				</div>

				<div id="bracket_matches" class={matches_classes.join(" ")} style={bracket_bg_styles}>
					{rounds.map((round, r) => {
						const round_number = round.round;

						let round_classes = ['bracket_round', 'round_' + round_number];
						if(round.reversed != undefined && round.reversed) round_classes.push('reversed');
						if(round.is_final != undefined && round.is_final) round_classes.push('is_final');

						return (
							<div key={`round_${r}`} class={round_classes.join(" ")} style={column_styles}>
								{round.matches.map((match, m) => {
									return (
										<RoundColumn key={`match_${r}_${m}`} match={match} round={round_number} {...round_props} />
									)
								})}
							</div>
						)
					})}
				</div>

				{(display_votes && display_round_votes !== false) && (
					<RoundVotesLayer pm={promotion} is_builder={is_builder} round={display_round_votes} matches_results={matches_results} bracket={bracket} teams={teams} main_color={main_color} backButton={() => setDisplayRoundVotes(false)} />
				)}
			</div>

			{(is_loading) && (
				<div class={`bracket_loading is_${bracket_layout}_loading`}>
					<Spinner color={(bracket_layout != 'light') ? '#FFFFFF' : '#000000'}>Loading</Spinner>
				</div>
			)}
		</div>
	);
}

export default injectIntl(BracketsCanvas);